import type {RGBA} from '@Utils/color.util';

export enum BorderType {
  NONE = 0,
  RECTANGLE_BORDER = 1,
  ROUNDED_BORDER = 2,
  STROKE_BORDER = 3,
}

export interface ItemBorderObject {
  solidBorderType: BorderType;
  solidBorderColor: RGBA;
  solidBorderThickness: number;
}
